// extracted by mini-css-extract-plugin
export default {"container":"GooglePayButton_container__VNxn5","buttonWrapper":"GooglePayButton_buttonWrapper__9-oGO"};